import StaffTable from 'components/Settings/Staff';
import { useSelector } from 'react-redux';

export const Staff = () => {
	const isAdmin = useSelector(
		(state: any) => state?.userProfile?.data?.isAdmin === true
	);

	return <div>{isAdmin && <StaffTable />}</div>;
};
